import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import {
	Avatar,
	Callout,
	Paragraph,
	Separator,
	Subheading,
	UnorderedList,
} from '@treams/treams-ui';

export default function MomentInfo(props: { user: graphql.User }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const primaryJobTitle = props.user.currentJobPosition?.jobTitle.title;
	const jobTitleLabel = primaryJobTitle
		? localize(primaryJobTitle).text
		: t('conversations.create.moment.noJobTitle');

	return (
		<>
			<Callout color="employee">{t('conversations.create.moment.managerWarning')}</Callout>
			<Box mt={3}>
				<Subheading>{t('conversations.create.moment.aboutMoment')}</Subheading>
				<Paragraph>{t('conversations.create.moment.consequences.explanation')}</Paragraph>
				<Paragraph ml={2}>
					<UnorderedList>
						<li>
							{t('conversations.create.moment.consequences.first', { name: props.user.firstName })}
						</li>
						<li>
							{t('conversations.create.moment.consequences.second', { name: props.user.firstName })}
						</li>
					</UnorderedList>
				</Paragraph>
				<Paragraph>{t('conversations.create.moment.aboutUser')}</Paragraph>
				<Flex mt={2} alignItems="center">
					<Box flexGrow={0} flexShrink={0} mr={3}>
						<Avatar user={props.user} size={32} />
					</Box>
					<Box flexGrow={1} flexShrink={1}>
						<Box>
							{props.user.firstName} {props.user.lastName}
						</Box>
						<Paragraph>{jobTitleLabel}</Paragraph>
					</Box>
				</Flex>
			</Box>
			<Separator my={3} />
		</>
	);
}
